import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  AfterViewInit,
  Output,
} from "@angular/core";
import { MixinFunctionsService } from "src/app/pages/services/mixin-functions.service";
@Component({
  selector: "app-dual-multi-select",
  templateUrl: "./dual-multi-select.component.html",
  styleUrls: ["./dual-multi-select.component.scss"],
})
export class DualMultiSelectComponent implements OnInit, AfterViewInit {
  //items: any[] = [];
  searchName = "";
  itemsToSelect = [];
  unfiltered = [];
  itemsToRemove = [];
  originalItems = [];
  isSearching: boolean;
  @Input() title: string;
  @Input() placeholder: string;
  @Input() filterByApi: boolean;
  @Input() labelAll: string;
  @Input() labelSelected: string;
  @Input() itemService;
  @Input() objectKey;
  @Input() items: Array<any>;
  @Input() selectedItems = [];
  @Output() selectionChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(private mixins: MixinFunctionsService) {}

  ngOnInit() {
    if (this.selectedItems == null) {
      this.selectedItems = [];
      this.unfiltered = this.items;
    }
    this.refreshList();
  }

  /**
   * Load items after view is complete initialized
   */
  ngAfterViewInit(): void {
    //this.loadItems({});
    // this.refreshList();
    this.originalItems = this.items.slice(0);
    this.items =
      this.originalItems.length > 0 ? this.originalItems : this.items;
  }
  ngOnDestroy(): void {
    // this.refreshList();
  }

  /**
   * Function to load items with optional search name
   * @param searchText = search string
   */
  loadItems(searchText) {
    this.isSearching = true;
    this.itemService.roles(searchText).subscribe(
      (items) => {
        //console.log(items);
        this.isSearching = false;
        this.items = items.data;
        this.refreshList();
      },
      (err) => {
        this.isSearching = false;
        console.log("error", err);
      }
    );
  }

  selectItem() {
    this.itemsToSelect.forEach((item) => {
      const idx = this.items.map((i) => i.id).indexOf(item.id);
      if (idx !== -1) {
        this.items.splice(idx, 1);
        this.selectedItems.push(item);
        this.itemsToSelect = [];
      }
    });
    this.selectionChanged.emit(this.selectedItems);
    this.refreshList();
  }

  selectAll() {
    this.items.forEach((item) => {
      this.selectedItems.push(item);
    });
    this.items = [];
    this.itemsToSelect = [];
    this.selectionChanged.emit(this.selectedItems);
    this.refreshList();
  }

  removeItem() {
    this.itemsToRemove.forEach((item) => {
      const idx = this.selectedItems.map((i) => i.id).indexOf(item.id);
      if (idx !== -1) {
        // JSON.parse(JSON.stringify(this.selectedItems)).splice(idx, 1);
        this.selectedItems.splice(idx, 1);
        this.items.push(item);
        this.items.sort((a, b) => {
          return a[this.objectKey] > b[this.objectKey] ? 1 : -1;
        });
        this.itemsToRemove = [];
      }
    });
    this.selectionChanged.emit(this.selectedItems);
    this.refreshList();
  }

  removeAll() {
    this.selectedItems.forEach((item) => {
      this.items.push(item);
      this.items.sort((a, b) => {
        return a[this.objectKey] > b[this.objectKey] ? 1 : -1;
      });
    });
    this.itemsToRemove = [];
    this.selectedItems = [];
    this.selectionChanged.emit(this.selectedItems);
    this.refreshList();
  }

  refreshList() {
    this.selectedItems.forEach((item) => {
      const idx = this.items.map((i) => i.id).indexOf(item.id);

      if (idx !== -1) {
        this.items.splice(idx, 1);
        this.items.sort((a, b) => {
          return a[this.objectKey] > b[this.objectKey] ? 1 : -1;
        });
      } else {
        this.items.sort((a, b) => {
          return a[this.objectKey] > b[this.objectKey] ? 1 : -1;
        });
      }
    });
  }

  searchItemsByNonApi(searchKey) {
    // console.log("unfiltered", this.unfiltered);
    this.items = this.mixins.filterData(searchKey, this.items, this.unfiltered);
  }

  searchItemsByApi(searchKey): void {
    this.loadItems({ name: searchKey.target.value });
  }

  filterList(searchKey) {
    if (this.filterByApi) {
      this.searchItemsByApi(searchKey);
    } else {
      this.searchItemsByNonApi(searchKey);
    }
  }

  get isSelected() {
    return Array.isArray(this.selectedItems) && this.selectedItems.length > 0
      ? true
      : false;
  }
}
